import React, { PureComponent } from 'react';
import { IPictureImage } from '../../../types';
import 'lazysizes';

interface IPictureProps {
  images: IPictureImage[];
  extension: string;
  altText: string;
  defaultImage?: number;
  className?: string[];
  handleOnLoad?: () => void;
}

interface IImageState {
  defaultSrc: string;
  sources: Array<{
    src: string;
    srcWebp: string;
    minWidth: number;
    sourceRef: React.MutableRefObject<HTMLSourceElement>;
  }>;
}

export default class PictureImage extends PureComponent<
  IPictureProps,
  IImageState
  > {
  private mainImageRef: React.MutableRefObject<HTMLImageElement>;
  private defaultImage: IPictureImage;
  constructor(props: IPictureProps) {
    super(props);
    this.defaultImage = this.props.defaultImage
      ? this.props.images[this.props.defaultImage]
      : this.props.images[0];
    this.state = {
      defaultSrc: require(`../../../assets/${this.defaultImage.imageName}.${this.props.extension}`),
      sources: this.props.images.map(image => ({
        srcWebp : require(`../../../assets/${image.imageName}.webp`),
        src: require(`../../../assets/${image.imageName}.${this.props.extension}`),
        minWidth: image.minWidth,
        sourceRef: React.createRef()
      }))
    };
    this.mainImageRef = React.createRef();
  }

  componentDidMount() {
    const defaultSrc = this.mainImageRef.current.getAttribute('data-src');
    if (
      defaultSrc.indexOf('$staticlink$') === -1 &&
      defaultSrc.indexOf('http') !== -1
    ) {
      this.setState(state => ({
        defaultSrc: defaultSrc,
        sources: state.sources.map(source => {
          return {
            ...source,
            src: source.sourceRef.current.getAttribute('data-srcset')
          };
        })
      }));
    }
  }

  render() {
    const { altText, handleOnLoad } = this.props;
    const { defaultSrc, sources } = this.state;
    return (
      <picture>
        {sources.map((source, index) => (
          <source
            key={'source_' + index}
            media={`(min-width: ${source.minWidth}px)`}
            data-srcset={source.srcWebp}
            ref={source.sourceRef}
            type="image/webp"
          />
        ))}
        {sources.map((source, index) => (
          <source
            key={'source_' + index}
            media={`(min-width: ${source.minWidth}px)`}
            data-srcset={source.src}
            ref={source.sourceRef}
          />
        ))}
        <img
          ref={this.mainImageRef}
          data-src={defaultSrc}
          alt={altText}
          onLoad={handleOnLoad}
          className={"lazyload " + this.props.className[0]}
        />
      </picture>
    );
  }
}
